import { productImageSizes } from '../../../constants';
import { aggregatingRatingSchema, offerSchema } from '../schemas';

const constructObjectDefault = (product, productRating, domain) => {
  var _product$image, _product$brand;

  const urlProduct = `${domain}${product == null ? void 0 : product.url}`;
  const aggregateContent = aggregatingRatingSchema(product.rating, productRating);
  const aggregateRating = !aggregateContent ? {} : {
    aggregateRating: aggregateContent
  };
  const offer = offerSchema(product, urlProduct);
  const offerContent = !offer ? {} : {
    offers: offer
  };
  return Object.assign({
    '@context': 'https://schema.org',
    '@type': 'Product'
  }, aggregateRating, {
    name: product.title,
    image: (_product$image = product.image) == null ? void 0 : _product$image.replace('{w}', productImageSizes.width).replace('{h}', productImageSizes.height),
    brand: (_product$brand = product.brand) == null ? void 0 : _product$brand.label,
    sku: product.id,
    description: product.description || product.title
  }, offerContent);
};

export default constructObjectDefault;